// Password rules and error messages for student sign-up (StudentSignUp.jsx).

// The password rules the account's Cognito pool enforces (Cognito's default policy, which is
// what the sign-up form has always described). Checked before submitting so a student learns
// which rule they missed; the server still has the final say.
export const PASSWORD_RULES = [
  { label: 'at least 8 characters', test: (value) => value.length >= 8 },
  { label: 'an uppercase letter', test: (value) => /[A-Z]/.test(value) },
  { label: 'a lowercase letter', test: (value) => /[a-z]/.test(value) },
  { label: 'a number', test: (value) => /[0-9]/.test(value) },
  { label: 'a symbol such as ! or #', test: (value) => /[^A-Za-z0-9]/.test(value) },
]

export const PASSWORD_HINT =
  'At least 8 characters, with an uppercase letter, a lowercase letter, a number and a symbol.'

const listOf = (items) =>
  items.length < 2 ? items.join('') : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`

// What the password still needs, as a sentence, or '' when it meets every rule.
export const passwordProblem = (password) => {
  const missing = PASSWORD_RULES.filter((rule) => !rule.test(password || '')).map((rule) => rule.label)
  return missing.length ? `Your password needs ${listOf(missing)}.` : ''
}

// What to tell the student about a failed sign-up. The backend answers with a code
// (routes/authRoute.js: EMAIL_EXISTS 409, INVALID_PASSWORD / INVALID_EMAIL 400,
// SIGNUP_BUSY 503). The form used to go by the status alone, so a password the pool
// rejected (400) was reported as "an account with this email already exists".
export const signUpErrorMessage = (error) => {
  const code = error?.response?.data?.code
  const status = error?.response?.status
  if (code === 'EMAIL_EXISTS' || status === 409 || error?.name === 'UsernameExistsException') {
    return 'An account with this email already exists. Try signing in instead.'
  }
  if (code === 'INVALID_PASSWORD' || error?.name === 'InvalidPasswordException') {
    return `That password isn't accepted. ${PASSWORD_HINT}`
  }
  if (code === 'INVALID_EMAIL' || error?.name === 'InvalidParameterException') {
    return 'Invalid email format. Please enter a valid email address.'
  }
  if (code === 'SIGNUP_BUSY' || status === 503) {
    return 'Lots of people are signing up right now. Please wait a few seconds and try again.'
  }
  return 'Something went wrong creating your account. Please try again.'
}
